import { FC, ReactNode } from "react";
import { Link } from "react-router-dom";
import { AppLogo } from "../AppLogo";

interface SplitLayoutProps {
  children: ReactNode;
  imageSrc?: string;
  imageAlt?: string;
}

export const SplitLayout: FC<SplitLayoutProps> = ({
  children,
  imageSrc,
  imageAlt = "Background",
}) => {
  return (
    <div className="flex min-h-screen">
      <div className={`w-full ${imageSrc ? "lg:w-1/2" : ""} flex flex-col`}>
        <div className="p-6 flex items-center border-b justify-center border-gray-200">
          <Link to="/" className="inline-block w-[82px]">
            <AppLogo />
          </Link>
        </div>

        <div className="flex-1 flex justify-center">
          <div className="w-full max-w-md pt-[80px]">{children}</div>
        </div>
      </div>

      {imageSrc && (
        <div className="hidden lg:block lg:w-1/2 relative">
          <img
            src={imageSrc}
            alt={imageAlt}
            className="absolute inset-0 w-full h-full object-cover"
          />
        </div>
      )}
    </div>
  );
};
